export default {

  getSurveyList() {
    return this.http('ExerciseCheck', 'get', 'api/v2/survey')
      .then((res) => {
        return res;
      });
  },

  postSurveyAnswer(params) {
    return this.http('ExerciseCheck', 'post', 'api/v2/survey', params)
      .then((res) => {
        return res;
      });
  },

  getEvaluations() {
    return this.http('SEAFARER', 'get', '/api/v1/evaluations')
      .then((res) => {
        return res;
      });
  },

  getSurveyHistory(params) {
    return this.http(
      'SEAFARER',
      'get',
      '/api/v1/evaluation_history',
      params
    ).then(res => {
      return res;
    });
  }
};
